module.exports = RedNaoInternalShared.default('InternalShared/Localization/LocalizeDate');